import { Injectable } from '@angular/core';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';

export interface ITakePictureData {
    fileData: string;
    fileName: string;
    fileType: string;
}

export enum FrontendMode {
    Website = 0,
    WebsiteIFrame = 1,
    MobileApp = 2,
}

@Injectable()
export abstract class MobileAppHelperBaseService {
    constructor() {}

    abstract isWebsite: boolean;
    abstract mobileAppMode: boolean;
    get frontEndMode() {
        if (this.mobileAppMode) {
            if (this.isWebsite) return FrontendMode.WebsiteIFrame;
            return FrontendMode.MobileApp;
        }
        return FrontendMode.Website;
    }

    postMessage(name, data?) {
        if (window.parent) {
            window.parent.postMessage(
                {
                    name: name,
                    data: data,
                },
                '*',
            );
        }
    }
    closeIFrame() {}

    abstract downloadFile(url: string, fileName: string, contentType?: string): Promise<void>;
    abstract openExternalLink(url: string);
    abstract checkOpenInternalLink(event: MouseEvent): boolean;
    abstract openChecklistViewer(checklistId: number, checklistName: string);
    abstract openFormViewer(formId: number, formName: string);
    abstract takePicture(callbackName: string): Promise<ITakePictureData>;
    abstract isMobileAppIos(): boolean;

    executeBackendRequestWithRetries<T>(
        fn: () => Promise<T>,
        params: {
            retriesCount?: number;
            delay?: number;
        } = null,
    ) {
        params = Object.assign(
            {
                retriesCount: 3,
                delay: 300,
            },
            params || {},
        );
        let retriesCount = params.retriesCount;

        const requestWrapper = () => {
            return new Promise<T>((resolve, reject) => {
                retriesCount--;
                fn()
                    .then((result) => {
                        resolve(result);
                    })
                    .catch((e) => {
                        if (e.status === 0 && retriesCount > 0) {
                            setTimeout(() => {
                                requestWrapper().then((r1) => {
                                    resolve(r1);
                                }, reject);
                            }, params.delay);
                        } else {
                            reject(e);
                        }
                    });
            });
        };

        return requestWrapper();
    }

    canCloseAppIFrame(key) {}

    openUpdateApp20Link() {}

    private isUpgradeToFlutterDialogOpened = false;
    showUpgradeToFlutterDialog(dialogsService: FiDialogsService, appTextService: AppTextService) {
        if (this.isUpgradeToFlutterDialogOpened) return;

        this.isUpgradeToFlutterDialogOpened = true;
        dialogsService
            .confirm({
                headerText: appTextService.get('upgrade.download_mobile_app_2.0'),
                messageText: appTextService.get('upgrade.download_mobile_app_2.0_message'),
                yesButtonText: appTextService.get('upgrade.download_mobile_app_2.0_yes_button'),
                config: {
                    maxWidth: '98%',
                },
            })
            .onYesButtonClick(() => {
                this.openUpdateApp20Link();
            })
            .afterClosed(() => (this.isUpgradeToFlutterDialogOpened = false));
    }
}
